import {CSSProperties, FC} from 'react';


export interface IIconSeatHeatBmwProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconSeatHeatBmw: FC<IIconSeatHeatBmwProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M18.594 4H17.28c-.775 0-1.406.63-1.406 1.406V6.72c0 .775.63 1.406 1.406 1.406h1.313c.775 0 1.406-.63 1.406-1.406V5.406C20 4.631 19.37 4 18.594 4ZM8.99 12.308l-.526-.527h1.723v1.724l-.534-.534a1.683 1.683 0 0 0-.396 1.658l-.976-.072a2.617 2.617 0 0 1 .71-2.25Zm2.407 0-.527-.527h1.724v1.724l-.534-.534a1.683 1.683 0 0 0-.329 1.84l1.612.12 2.29-6.496a1.397 1.397 0 0 1 .013-.04c.423.413 1 .668 1.635.668h1.313c.195 0 .385-.025.566-.07 0 .173-.026.347-.077.519L17.4 20H4v-3.574a2.034 2.034 0 0 1 1.854-2.022 2.615 2.615 0 0 1 .73-2.096l-.526-.527H7.78v1.724l-.534-.534a1.68 1.68 0 0 0-.44 1.477l1.474.109c.085.524.328 1.027.731 1.43.319.32.494.743.494 1.194 0 .451-.177.876-.496 1.195l.663.663c.496-.496.77-1.156.77-1.857 0-.702-.272-1.361-.768-1.857a1.67 1.67 0 0 1-.418-.696l1.466.108c.107.459.339.894.696 1.25.318.32.493.743.493 1.194 0 .451-.176.876-.496 1.195l.663.663c.496-.496.77-1.156.77-1.857.001-.702-.272-1.361-.768-1.857a1.672 1.672 0 0 1-.35-.513l-1.008-.075a2.62 2.62 0 0 1 .674-2.43Zm-4.793 6.068.663.663c.496-.496.77-1.156.77-1.857 0-.702-.272-1.361-.768-1.857a1.672 1.672 0 0 1-.463-.877l-.567-.042a2.015 2.015 0 0 0-.385-.003c.06.58.31 1.142.752 1.585.319.318.494.742.494 1.193 0 .451-.177.876-.496 1.195Z" clipRule="evenodd" />
        </svg>
    );
};
